<template>
  <div>
    <div>
      <v-select
        :items="presetNames"
        item-text="name"
        item-value="id"
        :label="label"
        dense
        outlined
        readonly
        @mouseup="onMouseUp"
        :value="value"
        :disabled="isDisabled"
        :rules="rules"
        :multiple="multiple"
      >
        <template v-slot:selection="{ item, index }">
          <v-chip v-if="index === 0" small>
            <span>{{ item.name }}</span>
          </v-chip>
          <span v-if="index === 1" class="grey--text caption">(+{{ value.length - 1 }} шт.)</span>
        </template>
      </v-select>
    </div>

    <div v-if="false">
      <div class="d-flex flex-row-reverse">{{ title }}</div>
      <div class="d-flex flex-row-reverse">
        <v-btn color="red darken-1" text @click="stopFetch = true">Отстановить загрузку</v-btn>
      </div>
    </div>

    <!-- dialog -->
    <v-dialog v-model="dialog" class="wapi_dialog__dialog" max-width="1100px" :scrollable="false">
      <v-card class="overflow-y-hidden wapi_dialog__dialog">
        <v-card-text>
          <v-row>
            <v-col>
              <div class="headline">{{ title }}</div>
              <v-checkbox
                v-if="multiple"
                class="ml-4"
                v-model="checkAll"
                :label="`Отметить все территории`"
              ></v-checkbox>
            </v-col>
            <!-- <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Поиск"
                  single-line
                  hide-details
            ></v-text-field>-->
          </v-row>
          <v-data-table
            :fixed-header="fixedHeader"
            :server-items-length="totalPresets"
            :options.sync="options"
            :height="tableHeight"
            :headers="headers"
            :single-select="!multiple"
            :items="presets"
            :value="dataTableSelected"
            @input="update"
            :show-select="multiple"
          >
            <template v-slot:item.area="{ item }">{{ areaInKm2(item.geoJson) }}</template>
            <template v-slot:item.actions="{ item }">
              <div class="my-2">
                <v-btn
                  small
                  :color="item.id === value ? 'success' : 'primary'"
                  @click="selectPreset(item)"
                >{{ item.id === value ? 'Выбрано' : 'Выбрать' }}</v-btn>
              </div>
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions class="pb-5 pr-2">
          <v-btn color="red darken-1" text @click="stopFetch = true">Отстановить загрузку</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="closeDialog">Закрыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { areaInKm2 } from "../helpers/common.js";

/**
 * Компонент выбора территориюй
 */
export default {
  name: "wapi-presets",
  props: {
    userId: {
      type: String,
      default: ""
    },
    /**
     * Список территорий
     */
    items: {
      type: Array,
      default: function() {
        return [];
      }
    },
    /**
     * Идентификаторы выбранных территорий
     */
    value: [String, Array],
    disabled: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: function() {
        return [];
      }
    },
    closeAfterSelect: {
      type: Boolean,
      default: false
    },
    initCheckAll: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dialogHeight() {
      return 700;
    },
    isDisabled() {
      return !(!!this.userId && this.presets.length);
    },
    isAdmin() {
      return this.$store.getters.IS_ADMIN;
    },
    tableHeight() {
      const defaultHeight = 530;
      const windowHeight = 890;
      if (window.innerHeight >= windowHeight) {
        return defaultHeight;
      }
      return defaultHeight - (windowHeight - window.innerHeight);
    },
    title() {
      if (this.multiple) {
        return `Выбранные территории ${this.value.length} / ${this.totalPresets}`;
      } else {
        return "Выберите территорию";
      }
    },
    checkAll: {
      get: function() {
        return this.value.length === this.totalPresets;
      },
      set: async function(value) {
        await this.$store.dispatch("SET_LOADING", true);
        await this.$store.dispatch(
          "PUSH_WARNING",
          "Операция может занять время"
        );
        this.stopFetch = false;
        this.localLoading = true;
        if (value) {
          const partLength = 50;
          const result = [];

          for (
            let index = 0;
            index < this.totalPresets;
            index = index + partLength
          ) {
            if (this.stopFetch) break;
            const presets = await this.$store.dispatch("FETCH_PRESETS", {
              userId: this.userId,
              take: partLength,
              skip: partLength * (index / partLength)
            });

            result.push(...presets);
            this.$emit("input", result);
            this.dataTableSelected = result;
          }
          this.localLoading = false;
          this.$nextTick(() => {
            this.$store.dispatch("SET_LOADING", false);
          });
        } else {
          this.$emit("input", []);
          this.dataTableSelected = [];
          this.localLoading = false;
          await this.$store.dispatch("SET_LOADING", false);
        }
      }
    },
    label() {
      if (this.noData) {
        return "Нет данных";
      }

      if (this.multiple) {
        return "Выберите территории";
      }
      return "Выберите территорию";
    },
    noData() {
      return this.presets.length === 0;
    },
    headers() {
      if (this.multiple) {
        return [
          { text: "Идентификатор территории", value: "id" },
          { text: "Имя территории", value: "name" },
          { text: "Площадь(км²)", value: "area" },
          { text: "Дата обновления", value: "up_time" }
        ];
      } else {
        return [
          { text: "Идентификатор территории", value: "id" },
          { text: "Имя территории", value: "name" },
          { text: "Площадь(км²)", value: "area" },
          { text: "Дата обновления", value: "up_time" },
          { text: "", value: "actions" }
        ];
      }
    }
  },
  methods: {
    /**
     * v-select
     */
    onMouseUp: async function() {
      if (!this.presets.length) {
        return;
      }

      if (this.disabled) {
        return;
      }
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },
    selectPreset(preset) {
      this.$emit("input", preset.id);
      if (this.closeAfterSelect) {
        this.dialog = false;
      }
    },
    update(newValue) {
      if (this.multiple) {
        this.$emit("input", newValue);
      } else {
        this.$emit("input", newValue.id);
      }
    },
    areaInKm2(geojson) {
      const area = Math.round(areaInKm2(geojson.geometry));
      return area;
    },
    forceRerender() {
      this.componentKey += 1;
    },
    async getPresets() {
      if (!this.userId) return;

      const { page, itemsPerPage } = this.options;

      if (this.isAdmin) {
        this.presets = await this.$store.dispatch("FETCH_PRESETS", {
          userId: this.userId,
          take: 10,
          skip: (page - 1) * itemsPerPage || 0
        });

        this.totalPresets = await this.$store.dispatch(
          "FETCH_PRESET_COUNT_USER",
          {
            userId: this.userId
          }
        );
      } else {
        this.presets = await this.$store.dispatch("FETCH_USER_PRESETS", {
          take: 10,
          skip: (page - 1) * itemsPerPage || 0
        });

        this.totalPresets = await this.$store.dispatch(
          "FETCH_PRESET_COUNT",
          {}
        );
      }
    }
  },
  data() {
    return {
      fixedHeader: true,
      componentKey: 0,
      localLoading: false,
      dialog: false,
      search: "",
      page: 1,
      paginationTotalVisible: 10,
      perPage: 6,
      dataTableSelected: [],
      options: {},
      totalPresets: 0,
      presets: [],
      stopFetch: false,
      presetNames: []
    };
  },
  watch: {
    async initCheckAll(val) {
      if (val && this.userId) {
        await this.getPresets();
        this.checkAll = true;
      }
    },
    async userId() {
      this.totalPresets = 0;
      this.dataTableSelected = [];
      this.presetNames = await this.$store.dispatch("FETCH_PRESET_NAMES", {
        userId: this.userId,
        take: 10000,
        skip: 0
      });

      await this.getPresets();
    },
    options: {
      handler() {
        this.getPresets();
      },
      deep: true
    }
  }
};
</script>